import { CheckmarkIcon } from 'components/CustomIcon';
import { useTranslation } from 'react-i18next';
import { Container, Title, Text } from './StepReturnApproved.styles';

export const StepReturnApproved = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <CheckmarkIcon width={56} height={56} />
      <Title>{t('RETURN_REQUEST_APPROVED')}</Title>
      <Text>{t('RETURN_REQUEST_APPROVED_TEXT')}</Text>
    </Container>
  );
};
